module.exports = __webpack_public_path__ + "img/SEND_MESSAGE.63e9d03f.svg";